module.exports = __webpack_public_path__ + "static/img/风险级场景_产品图_image@2x.0dbc94dd.png";